import React from "react";
import { useTranslation } from "react-i18next";

import { LinkedinData } from "./types/LinkedinData";
import './linkedin.css';

type LinkedinPostProps = {
    post: LinkedinData
}

const LinkedinPost = ({post} : LinkedinPostProps): React.JSX.Element => {

    const {t} = useTranslation();
    return (
        <div className="linkedin-post small">
            <div className="header">
                <div className="avatar">
                    <img src={post.userImgSrc !== undefined ? post.userImgSrc : ""}/>
                </div>
                <div className="user-infos small">
                    <div className="user-name">{post.userName}</div>
                    {/* <div className="user-role">{post.userRole}</div> */}
                    <div className="post-date">{post.postDate}</div>
                </div>
            </div>
            <div className="content">
                <div className="post-message">
                    <p dangerouslySetInnerHTML={
                        { __html: post.postMessage }
                    } />
                </div>
                <div className="post-img">
                    <img src={post.postImgSrc !== undefined ? post.postImgSrc : ""}/>
                </div>
                <div className="overlay"></div>
                <div className="post-link">
                    <a href={post.postLink} target="_blank">{t('Pages.Home.ButtonMore')} </a>
                </div>
            </div>
        </div>
    );
}

export default LinkedinPost;